import { includes } from "lodash";

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
    // 检查用户是否拥有 SUPER_ADMIN 角色
  const isSuperAdmin = currentUser?.roles?.some(role => role.roleCode === 'SUPER_ADMIN');
  return {
    // canAdmin: currentUser && currentUser.access === 'admin',
    //能用manage就是用manage判断，view是显示，其他地方筛选也会使用
    canSuperAdmin: isSuperAdmin,
    canViewStatistics: currentUser?.permissions?.includes('statistics.view'),
    canManageUser: currentUser?.permissions?.includes('user.manage'),
    canUserSoftwareManagement:currentUser?.permissions.includes("user.userSoftwareManage"),
    canManageDepartment: currentUser?.permissions?.includes('department.manage'),
    canManageSoftware: currentUser?.permissions?.includes('software.manage'),
    canManageDevice: currentUser?.permissions?.includes('device.manage'),
    canManageAuthorization: currentUser?.permissions?.includes('authorization.manage'),
    canManageRole: currentUser?.permissions?.includes('role:manage'),
    canManageNotification: currentUser?.permissions?.includes('notification.manage'), // 权限控制通知管理
    canManageBackdoor: isSuperAdmin,
     // 软件管理菜单的权限：只要有一个子菜单有权限，就显示
    canAccessSoftwareMenu: 
      currentUser?.permissions?.includes('software.manage') ||
      currentUser?.permissions?.includes('device.manage') ||
      currentUser?.permissions?.includes('authorization.manage')
  };
}
